import { render, staticRenderFns } from "./CuringReCheck.vue?vue&type=template&id=619d55cc&scoped=true&"
import script from "./CuringReCheck.vue?vue&type=script&lang=js&"
export * from "./CuringReCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d55cc",
  null
  
)

export default component.exports